const toTrimmedString = (value) =>
  typeof value === "string" || typeof value === "number"
    ? String(value).trim()
    : "";

const normalizeCollectionPath = (value) =>
  toTrimmedString(value).replace(/^\/+|\/+$/g, "");

const getCommentAuthorUserId = (comment = {}) =>
  toTrimmedString(comment?.userId);

const getCommentId = (comment = {}) => toTrimmedString(comment?.id);

const isDeletedComment = (comment = {}) =>
  comment?.isDeleted === true || toTrimmedString(comment?.author) === "[deleted]";

const isAiResponseComment = (comment = {}) =>
  comment?.byAi === true ||
  toTrimmedString(comment?.author) === "AI Response" ||
  toTrimmedString(comment?.userId) === "ai-response-agent";

export const canOpenCommentAuthorContact = (
  comment = {},
  canModerate = false,
) => Boolean(canModerate) &&
  !isDeletedComment(comment) &&
  !isAiResponseComment(comment) &&
  Boolean(getCommentId(comment)) &&
  Boolean(getCommentAuthorUserId(comment));

export const buildCommentAuthorContactRequest = (
  comment = {},
  context = {},
) => {
  const canModerate =
    Object.prototype.hasOwnProperty.call(context, "canModerate")
      ? context.canModerate
      : true;

  if (!canOpenCommentAuthorContact(comment, canModerate)) {
    return null;
  }

  const request = {
    itemId: toTrimmedString(context.itemId),
    commentId: getCommentId(comment),
  };
  const sourceCollectionPath = normalizeCollectionPath(
    context.sourceCollectionPath,
  );
  const bankId = toTrimmedString(context.bankId);
  const rowState = toTrimmedString(context.rowState);

  if (!request.itemId || !request.commentId) {
    return null;
  }

  if (sourceCollectionPath) {
    request.sourceCollectionPath = sourceCollectionPath;
  }
  if (bankId) {
    request.bankId = bankId;
  }
  if (rowState) {
    request.rowState = rowState;
  }

  if (!request.sourceCollectionPath && !request.bankId) {
    return null;
  }

  if (request.sourceCollectionPath === "flashcards" && !request.bankId) {
    return null;
  }

  return request;
};
